import { generateMetadata as e } from "./generateMetadata.js";
//#region src/logger/helpers/generateApiMetadata.ts
var t = (t, n, r) => e(Object.assign(r, {
	service: t,
	webservice: n
}));
//#endregion
export { t as generateApiMetadata };

//# sourceMappingURL=generateApiMetadata.js.map